export const breakpoints = {
  xs: 0,
  sm: 480,
  md: 768,
  lg: 1024,
  xl: 1280,
};

export const media = {
  sm: `@media (min-width: ${breakpoints.sm}px)`,
  md: `@media (min-width: ${breakpoints.md}px)`,
  lg: `@media (min-width: ${breakpoints.lg}px)`,
  xl: `@media (min-width: ${breakpoints.xl}px)`,
};

const theme = {
  breakpoints,
  media,
  colors: {
    background: '#f6f1ea',
    surface: '#fffdf9',
    surfaceMuted: '#efe4d6',
    text: '#1f1a17',
    textMuted: '#5f554e',
    border: 'rgba(31, 26, 23, 0.12)',
    accent: '#b86b52',
    accentStrong: '#8f4b35',
    accentSoft: '#f5d2bf',
    inverseText: '#fffaf5',
    overlay: 'rgba(18, 12, 9, 0.38)',
  },
  fonts: {
    body: "'Manrope', 'Segoe UI', sans-serif",
    display: "'Sora', 'Manrope', 'Segoe UI', sans-serif",
  },
  fontSizes: {
    hero: 'clamp(2.9rem, 7vw, 5.75rem)',
    h1: 'clamp(2.25rem, 4vw, 4rem)',
    h2: 'clamp(1.9rem, 3vw, 3rem)',
    h3: 'clamp(1.5rem, 2.2vw, 2.1rem)',
    bodyLg: 'clamp(1.0625rem, 1.3vw, 1.25rem)',
    body: 'clamp(1rem, 1vw, 1.125rem)',
    small: '0.95rem',
    label: '0.875rem',
  },
  lineHeights: {
    tight: 1.05,
    heading: 1.1,
    body: 1.65,
  },
  spacing: {
    xs: '0.5rem',
    sm: '0.75rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    '2xl': '3rem',
    '3xl': '4rem',
    '4xl': '6rem',
  },
  container: {
    maxWidth: 'min(1120px, calc(100% - 2rem))',
    narrow: 'min(760px, calc(100% - 2rem))',
    wide: 'min(1280px, calc(100% - 2rem))',
  },
  radii: {
    sm: '0.75rem',
    md: '1rem',
    lg: '1.5rem',
    pill: '999px',
  },
  shadows: {
    sm: '0 10px 30px rgba(28, 19, 15, 0.08)',
    md: '0 18px 40px rgba(28, 19, 15, 0.12)',
  },
  layout: {
    headerHeight: '88px',
    headerHeightMobile: '72px',
  },
};

export default theme;
